/** Tool to check for string type */
export const isString = (value: unknown): boolean => typeof value === 'string';

/** Tool to check for object type */
export const isObject = (value: unknown): boolean => typeof value === 'object';

/** Tool to check for undefined */
export const isUndefined = (value?: unknown): boolean => typeof value === 'undefined';

/** Tool to check for null or undefined */
export const isNullOrUndefined = (value?: unknown | null): boolean =>
  typeof value === 'undefined' || !value;

/** Tool to check for whether an array or string is undefined or empty */
export const isEmpty = (value?: string | unknown[] | null): boolean => !value || value.length === 0;

/** Tool to check for whether a provided value is present */
export const isValuePresent = (value?: string | number | object | null) => {
  if (value === null) {
    return false;
  }

  if (isString(value)) {
    return /\S/.test(String(value));
  }

  if (isObject(value)) {
    return !isEmpty(String(value));
  }

  return !!value || value === 0;
};

/** Creates a clone of the provided object and ensures it creates a new reference in memory. */
export const deepClone = (value: object) => JSON.parse(JSON.stringify(value));
